import get from 'lodash.get';
import moment from 'moment';

// Utils
// @ts-ignore
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

interface ITimesheetTimesheetEntriesAPIError {
    error: string;
    uuids?: string[];
    details?: Array<
        Array<{
            uuid: string;
            personFirstName: string;
            personLastName: string;
            workTypeName: string;
            entityName: string;
            date: string;
            startTime: string;
            endTime: string;
        }>
    >;
}

interface IState {
    timesheetTimesheetEntriesAPIErrors: ITimesheetTimesheetEntriesAPIError[];
}

interface IProps {
    timesheetEntryUuid?: string;
}

const selectTimesheetTimesheetEntriesAPIErrors = (state: IState) =>
    state.timesheetTimesheetEntriesAPIErrors;
const selectTimesheetEntryUuid = (state: IState, props: IProps) =>
    props.timesheetEntryUuid;

const selectTimesheetEntryApiErrors = createDeepEqualSelector(
    selectTimesheetTimesheetEntriesAPIErrors,
    (
        timesheetTimesheetEntriesErrorErrorsState: ITimesheetTimesheetEntriesAPIError[]
    ) => {
        if (
            timesheetTimesheetEntriesErrorErrorsState &&
            timesheetTimesheetEntriesErrorErrorsState.length
        ) {
            return timesheetTimesheetEntriesErrorErrorsState.reduce<{
                [key: string]: string;
            }>((accumulator, currentValue) => {
                const { error, details, uuids } = currentValue;
                if (uuids) {
                    uuids.forEach((uuid) => {
                        accumulator[uuid] = error;
                    });
                }
                if (details && details.length) {
                    details.forEach((value) => {
                        const { uuid } = value[0];
                        const {
                            personFirstName,
                            personLastName,
                            workTypeName,
                            entityName,
                            date,
                            startTime,
                            endTime
                        } = value[1];
                        accumulator[
                            uuid
                        ] = `${error}: ${personFirstName} ${personLastName} is already performing ${workTypeName} in ${entityName} on ${moment(
                            date,
                            'YYYY-MM-DD'
                        ).format('DD/MM/YYYY')}, from ${moment(
                            startTime,
                            'HH:mm:ss'
                        ).format('h:mm a')} - ${moment(
                            endTime,
                            'HH:mm:ss'
                        ).format('h:mm a')}`;
                    });
                }
                return accumulator;
            }, {});
        }
        return {};
    }
);

const selectTimesheetEntriesApiErrorUuids = createDeepEqualSelector(
    selectTimesheetEntryApiErrors,
    (timesheetEntryApiErrorsState: ITimesheetTimesheetEntriesAPIError[]) =>
        Object.keys(timesheetEntryApiErrorsState)
);

const selectTimesheetEntriesApiErrorMessages = createDeepEqualSelector(
    selectTimesheetEntryApiErrors,
    (timesheetEntryApiErrorsState: ITimesheetTimesheetEntriesAPIError[]) =>
        Object.values(timesheetEntryApiErrorsState)
);

const makeSelectTimesheetEntryApiError = () =>
    createDeepEqualSelector(
        [selectTimesheetEntryApiErrors, selectTimesheetEntryUuid],
        (
            timesheetEntryApiErrorsState: ITimesheetTimesheetEntriesAPIError[],
            timesheetEntryUuidProp: string
        ) => get(timesheetEntryApiErrorsState, timesheetEntryUuidProp)
    );

const makeSelectTimesheetEntryApiErrorExists = () =>
    createDeepEqualSelector(
        makeSelectTimesheetEntryApiError(),
        (timesheetEntryApiErrorState?: string) => !!timesheetEntryApiErrorState
    );

export {
    selectTimesheetEntryApiErrors,
    selectTimesheetEntriesApiErrorUuids,
    selectTimesheetEntriesApiErrorMessages,
    makeSelectTimesheetEntryApiError,
    makeSelectTimesheetEntryApiErrorExists
};
